/**
 * TermsOfUse.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import EditablePage from './EditablePage';
import SEO from './SEO';
import { useLanguage } from '../context/LanguageContext';
import { getTranslatedPage } from '../i18n/pages';

export default function TermsOfUse() {
  const { language } = useLanguage();
  const tr = getTranslatedPage('terms-of-use', language);
  return (
    <>
      <SEO 
        title={`${tr?.title || 'Terms of Use'} | Cranford Publications`}
        description={tr?.description || 'Read the terms and conditions for using Cranford Publications website and purchasing our Celtic music products.'}
        canonical="/terms-of-use"
        keywords="terms of use, terms and conditions, website terms"
      />
      <EditablePage pageId="terms-of-use" pageTitle={tr?.title || 'Terms of Use'} />
    </>
  );
} 